module.exports = __webpack_public_path__ + "static/media/playImg.cf87a3c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Article/ArticleCard/playImg.png
// module id = 551
// module chunks = 1